/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoControlCenterModelsDigitizingOrderListItem,
    ControlcenterMelcoControlCenterModelsDigitizingOrderListItemFromJSON,
    ControlcenterMelcoControlCenterModelsDigitizingOrderListItemFromJSONTyped,
    ControlcenterMelcoControlCenterModelsDigitizingOrderListItemToJSON,
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItem
 */
export interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItem {
    /**
     * 
     * @type {Array<ControlcenterMelcoControlCenterModelsDigitizingOrderListItem>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItem
     */
    list: Array<ControlcenterMelcoControlCenterModelsDigitizingOrderListItem>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItem
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItem
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItemFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItem {
    return ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoControlCenterModelsDigitizingOrderListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItemToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoControlCenterModelsDigitizingOrderListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


